import req from './request'

const DEFAULT_ENDPOINTS = {
    noComplete: '/dumpsFinished/marketing/no-complete',
    Complete: '/dumpsFinished/marketing/complete',
    Statistic: '/dumps/marketing/statistic',
    calling: '/dumpsFinished/calling',
    driver: '/dumpsFinished/driver-info/general',
    promotion: '/dumpsFinished/driver-info/promotions',
    toWork: '/dumpsFinished/driver-info/to-work',
    comments: '/dumpsFinished/driver-info/comments',
    addcomment: '/dumpsFinished/driver-info/add-comment',
    assetCall: '/dumpsFinished/asset-call'
}

export default {
    noComplete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.noComplete, param)
    },
    complete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Complete, param)
    },
    statistic(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Statistic, param)
    },
    calling(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.calling, param)
    },
    driver(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driver, param)
    },
    promotion(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.promotion, param)
    },
    toWork(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.toWork, param)
    },
    comments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.comments, param)
    },
    addcomment(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.addcomment, param)        
    },
    assetCall(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.assetCall, param)
    }
}